let lastsearch = "";
let available_results = [];

$('#searchbar').select2({
    dropdownCssClass : 'big-search-results',
    language: {
        errorLoading: function () {
          return "Er ging iets fout";
        },
        inputTooShort: function (args) {
            let remainingChars = args.minimum - args.input.length;

            let message = 'Typ ' + remainingChars + ' extra letters';

            return message;
        },
    },
    dropdownAutoWidth: true,
    tags: false,
    placeholder: 'Zoeken',
    minimumInputLength: 3,
    width: '100%',
    templateResult: formatProduct,
    ajax: {
        url: window.location.origin + '/livesearch/products',
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: function (params) {
            var queryParameters = {
                search: params.term,
                type: 'searchbar',
            }
            lastsearch = params.term;
            return queryParameters;
        },
        processResults: function (data) {
            available_results = data;
            return {
                results: $.map(data, function (item) {
                    return {
                        text: item.title,
                        id: item.id,
                        filename: item.filename,
                        url: item.url
                    }
                })
            };
        },
    },
});

$('#searchbar').on('select2:select', function (e) {
    if ($('#searchbar').select2().val() == 0) {
        window.location.href = "/search/" + lastsearch;
    } else {
        $.ajax({
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',
            url: window.location.origin + '/livesearch/products',
            data: {
                search: e.target.children[0].value,
                type: 'productexists',
            },
            success: function (data) {
                if (data && available_results) {
                    let search = e.target.children[0].text;
                    const asArray = Object.entries(available_results);
                    let foundItems = asArray.filter((item) =>
                        item[1].title.replace(/\s+/g, '') === search.replace(/\s+/g, '')
                    );
                    let redirectUrl = window.location.origin + foundItems[0][1].url;
                    console.log(redirectUrl);
                    window.location.href = redirectUrl;
                }
            },
            error: function (data) {
                //
            }
        });
    }
});

function formatProduct (state) {
    if (!state.disabled) {
        if (state.filename == "" && state.id != -1 && state.id != -2) {
            return state.text;
        } else if (state.id == -1) {
            return "Geen resultaten";
        }

        var baseUrl = window.location.origin;
        var $state = $(
            '<span><img width="150" height="150" src="' + baseUrl + state.filename + '" class="img-flag" /> <br /><strong>' + state.text + '</strong></span>'
        );
        return $state;
    }
}

// Reset de admin-zoekwidget (zoek in alle klanten) bij het openen van de modal
$('#customerModal').on('show.bs.modal', function() {
    if ($('#customer-search').length > 0) {
        $('#customer-search').val('');
        $('#customer-search-result').html('Nog geen zoekopdracht uitgevoerd');
        $('#customer-select-id').html('<option selected disabled>Zoek eerst hierboven</option>').prop('disabled', true);
    }
});

// Set focus on admin search field when modal is fully shown
$('#customerModal').on('shown.bs.modal', function() {
    if ($('#customer-search').length > 0) {
        $('#customer-search').focus();
    }
});

$('#customer-select-id').on('change', function (e){
    let customerid = $(this).val();
    $.ajax({
        type : 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        url: window.location.origin + '/winkelwagen/klant',
        data:{
            customerid:  customerid,
        },
        success:function(data){
            // Pas herladen als het inloggen-als-klant is afgehandeld: eerder herladen brak dat verzoek
            // af en gaf de melding 'An error occurred.' terwijl de wissel soms toch doorging (FEKO-1311).
            $.ajax({
                type : 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                dataType: 'json',
                url : `/auth/impersonate`,
                data:{
                    customer_id: customerid,
                },
                success: function(response) {
                    // Zonder gebruiker bij de klant is inloggen-als niet mogelijk; de klant is dan wel geselecteerd.
                    window.location.reload(true);
                },
                error: function(xhr) {
                    alert('De klant kon niet geselecteerd worden (fout ' + xhr.status + '). Probeer het opnieuw.');
                }
            });
        },
        error:function(xhr) {
            alert('De klant kon niet geselecteerd worden (fout ' + xhr.status + '). Probeer het opnieuw.');
        }
    });
});

$('#customer-search').on('keyup', function (e) {
    $("#customer-search-submit").prop("disabled", true);
    let str = $(this).val();
    if (str.length > 1) {
        $.ajax({
            url: "/admin/customer/search",
            type: "GET",
            data: {
                search: str
            },
            success: function (data) {
                $("#customer-select-id").prop("disabled", false);
                if (data.length === 0) {
                    $("#customer-search-result").html("Geen resultaten gevonden.");
                    $("#customer-select-id").html("<option selected disabled>Probeer opnieuw</option>");

                } else {
                    $("#customer-search-result").html('Er zijn ' + data.length + ' resultaten gevonden.');
                    $("#customer-search-submit").prop("disabled", false);
                    $("#customer-select-id").html("<option selected disabled>Kies een optie:</option>");
                }
                for (var i = 0; i < data.length; i++) {
                    $("#customer-select-id").append("<option class='customer-selection-item' value=" + data[i].id + ">" + data[i].name + "</option>");
                }
            }
        });
    } else {
        $("#customer-select-id").prop("disabled", true);
        // Clear result div
        $("#customer-search-result").html('Vul minstens 1 tekens in om te zoeken.');
    }
});

// Global function for representative customer selection
window.selectRepCustomer = function() {
    var customerid = $('#rep-customerid').val();
    if (!customerid) {
        alert('Selecteer eerst een klant');
        return;
    }

    $.post('/winkelwagen/klant', {
        _token: $('meta[name="csrf-token"]').attr('content'),
        customerid: customerid
    }).done(function() {
        window.location.reload();
    }).fail(function() {
        alert('Er ging iets mis');
    });
};

// ============================================
// Representative customer filter functionality
// ============================================

let repUserTypedText = '';

// Filter representative customer dropdown based on search input
$('#rep-customer-filter').on('keydown', function(e) {
    let $select = $('#rep-customerid');
    let $input = $(this);

    // Handle arrow up/down keys
    if (e.key === 'ArrowDown' || e.keyCode === 40) {
        e.preventDefault();

        let visibleOptions = $select.find('option:visible').filter(function() {
            return $(this).val() !== '';
        });

        if (visibleOptions.length === 0) return;

        let currentIndex = -1;
        visibleOptions.each(function(index) {
            if ($(this).val() === $select.val()) {
                currentIndex = index;
            }
        });

        let nextIndex = currentIndex + 1;
        if (nextIndex >= visibleOptions.length) nextIndex = 0;

        let nextOption = visibleOptions.eq(nextIndex);
        $select.val(nextOption.val());

        updateRepInputWithSelection($input, nextOption.text());
    } else if (e.key === 'ArrowUp' || e.keyCode === 38) {
        e.preventDefault();

        let visibleOptions = $select.find('option:visible').filter(function() {
            return $(this).val() !== '';
        });

        if (visibleOptions.length === 0) return;

        let currentIndex = -1;
        visibleOptions.each(function(index) {
            if ($(this).val() === $select.val()) {
                currentIndex = index;
            }
        });

        let prevIndex = currentIndex - 1;
        if (prevIndex < 0) prevIndex = visibleOptions.length - 1;

        let prevOption = visibleOptions.eq(prevIndex);
        $select.val(prevOption.val());

        updateRepInputWithSelection($input, prevOption.text());
    }
});

$('#rep-customer-filter').on('keyup', function(e) {
    // Ignore arrow keys and enter - handled in keydown
    if (e.key === 'ArrowDown' || e.keyCode === 40 ||
        e.key === 'ArrowUp' || e.keyCode === 38 ||
        e.key === 'Enter' || e.keyCode === 13) {

        if (e.key === 'Enter' || e.keyCode === 13) {
            let $select = $('#rep-customerid');
            let selectedValue = $select.val();

            if (selectedValue && selectedValue !== '') {
                selectRepCustomer();
            }
        }
        return;
    }

    // Handle Tab key to autocomplete
    if (e.key === 'Tab' && e.keyCode === 9) {
        let ghostText = $('#rep-customer-filter-ghost').val();
        if (ghostText) {
            e.preventDefault();
            $(this).val(ghostText);
            repUserTypedText = ghostText;
            $('#rep-customer-filter-ghost').val('');
        }
        return;
    }

    // Update user typed text for normal keys
    repUserTypedText = $(this).val();

    let searchTerm = $(this).val().toLowerCase();
    let $select = $('#rep-customerid');
    let firstVisibleOption = null;
    let $ghostInput = $('#rep-customer-filter-ghost');

    $select.find('option').each(function() {
        let optionText = $(this).text().toLowerCase();
        let optionValue = $(this).val();

        // Always show the placeholder option but don't select it
        if (optionValue === '') {
            $(this).show();
            return;
        }

        if (optionText.indexOf(searchTerm) > -1) {
            $(this).show();

            if (firstVisibleOption === null) {
                firstVisibleOption = $(this);
            }
        } else {
            $(this).hide();
        }
    });

    // Auto-select the first visible option and update ghost text
    if (firstVisibleOption !== null) {
        $select.val(firstVisibleOption.val());

        let firstMatchText = firstVisibleOption.text();
        let currentInput = $(this).val();

        if (currentInput.length > 0 && firstMatchText.toLowerCase().startsWith(currentInput.toLowerCase())) {
            $ghostInput.val(currentInput + firstMatchText.substring(currentInput.length));
        } else {
            $ghostInput.val('');
        }
    } else {
        $select.val('');
        $ghostInput.val('');
    }
});

// Helper function to update input field with selected customer name (representative)
function updateRepInputWithSelection(inputElement, selectedText) {
    let $input = inputElement;
    let $ghostInput = $('#rep-customer-filter-ghost');
    let typedLength = repUserTypedText.length;

    $input.val(selectedText);
    $ghostInput.val(selectedText);

    if (typedLength > 0 && typedLength < selectedText.length) {
        setTimeout(function() {
            if ($input[0].setSelectionRange) {
                $input[0].setSelectionRange(typedLength, selectedText.length);
            }
        }, 0);
    }
}

// Reset representative filter when modal is opened
$('#customerModal').on('show.bs.modal', function() {
    // Representative filter reset
    $('#rep-customer-filter').val('');
    $('#rep-customer-filter-ghost').val('');
    $('#rep-customerid option').show();
    repUserTypedText = '';

    // Check if there's only 1 customer for representative
    let $repSelect = $('#rep-customerid');
    if ($repSelect.length > 0) {
        let nonPlaceholderOptions = $repSelect.find('option').filter(function() {
            return $(this).val() !== '';
        });

        if (nonPlaceholderOptions.length === 1) {
            $repSelect.val(nonPlaceholderOptions.first().val());
            $('#rep-customer-filter').val(nonPlaceholderOptions.first().text());
        }
    }
});

// Set focus on representative search field when modal is fully shown
$('#customerModal').on('shown.bs.modal', function() {
    if ($('#rep-customer-filter').length > 0) {
        $('#rep-customer-filter').focus();
        $('#rep-customerid').css('cursor', 'pointer');
    }
});

// Trigger selection on click or double-click for representative dropdown
$('#rep-customerid').on('click', function(e) {
    let $select = $(this);
    let selectedValue = $select.val();

    let nonPlaceholderOptions = $select.find('option:visible').filter(function() {
        return $(this).val() !== '';
    });

    if (nonPlaceholderOptions.length === 1 && selectedValue && selectedValue !== '') {
        selectRepCustomer();
    }
});

$('#rep-customerid').on('dblclick', function(e) {
    let selectedValue = $(this).val();
    if (selectedValue && selectedValue !== '') {
        selectRepCustomer();
    }
});
